import http from '../UserService'

export const getBranchData = (id) => {
    return http.get(`user/branch/?store=${id}/`)
}

export const getBranchRouteDate = (id) => {
    return http.get(`user/branch/${id}/`)
}